import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { textAlign } from 'styled-system';

import sx from '../../internal/styles/sx';
import { TableHeaderProps } from './types';

const TableHeader = styled('th', { shouldForwardProp })<TableHeaderProps>(
  textAlign,
  css({
    paddingTop: '0',
    verticalAlign: 'bottom',
    boxSizing: 'border-box',
    fontWeight: 'normal',
  }),
  sx
);

export default TableHeader;
